module.exports = "<section>\r\n    <h1 class=\"<%= heading %>\" ng-bind=\"$ctrl.title\"></h1>\r\n\r\n    <p class=\"<%= infoMessage %>\" ng-bind=\"$ctrl.message\"></p>\r\n\r\n    <footer class=\"<%= footerWrapper %>\">\r\n        <a ng-click=\"$ctrl.backToSignIn()\">{{\"auth.components.common.AuthConfirmationMessage.Back to Sign In\" | translate}}</a>\r\n    </footer>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/api/gw-portals-auth-angular/components/common/AuthConfirmationMessage/AuthConfirmationMessage.html
// module id = 538
// module chunks = 0